<template>
  <input 
    class="input-item"
    :class="{'disabled': readonly}" 
    :type="inputType"
    placeholder="请输入"
    v-model="itemValue"
    @input="onValueChange()"
  />
</template>

<script>

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null
    };
  },
  computed: {
    inputType() {
      let type = 'text';
      if (this.item.type === 'phone') {
        type = 'tel'
      }
      return type;
    }
  },
  components: {
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      this.itemValue = this.submitValue?.value || '';
    },
    // 【2】值监听
    onValueChange() {
      this.$emit('change', {
        value: this.itemValue
      });
    }
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.input-item {
  .input-item();
}
</style>
